export const additionalRequirements = {
  onboardingSteps: [
    {
      key: 'stock_footage',
      name: 'Stock Footage',
      status: 'empty',
      type: 'single',
      hero: 'Does this project require stock footage or pictures?',
      description: 'Select one that applies.',
      selectedValue: [],
      cards: [
        {
          label: 'No',
          text: '',
          value: 'no',
          noIcon: true,
        },
        {
          label: 'Yes, I have them',
          text: '',
          value: 'have_them',
          noIcon: true,
        },
        {
          label: 'Yes, but I need you to create them.',
          is_hand: true,
          text: '',
          value: 'help_creating',
          noIcon: true,
        },
        {
          label: "I don't know, and I need help.",
          is_hand: true,
          text: '',
          value: 'dont_know',
          noIcon: true,
        },
      ],
    },
    {
      key: 'voiceover',
      status: 'empty',
      name: 'Voiceover',
      type: 'single',
      hero: 'Does this project require a voice over?',
      description:
        'We work with a talented pool of male and female voiceover artists from Voice Bunny to choose from if needed.',
      selectedValue: [],
      cards: [
        {
          label: 'No',
          text: '',
          value: 'no',
          noIcon: true,
        },
        {
          label: 'Yes, I will provide a final version.',
          text: '',
          value: 'final_version',
          noIcon: true,
        },
        {
          label: 'Yes, but I need help creating.',
          is_hand: true,
          text: '',
          value: 'help_creating',
          noIcon: true,
        },
        {
          label: "I don't know, and I need help.",
          is_hand: true,
          text: '',
          value: 'dont_know',
          noIcon: true,
        },
      ],
    },
  ],
};



// WEBPACK FOOTER //
// ./src/store/reducers/Onboarding/overviewSteps/additionalRequirements.js